<template>
  <div>
    <carousel :items-to-show="1">
      <slide v-for="(slider, index) in sliders" :key="index">
        <div target="_blank" class="wide-screen no-scale">
          <img v-lazy="slider" />
        </div>
      </slide>

      <template #addons>
        <navigation v-if="sliders.length > 1" />
      </template>
    </carousel>
  </div>
</template>
 
<script>
  import 'vue3-carousel/dist/carousel.css';
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

  export default {
    components: {
      Carousel,
      Slide,
      Pagination,
      Navigation
    },
    props: ['paramSliders'],
    data() {
      return {
        sliders: [],
      }
    },
    mounted() {
      this.sliders = JSON.parse(this.paramSliders);
    }
  }
</script>

<style lang="scss">
.carousel__prev--in-active,
.carousel__next--in-active {
  display: none;
}

.carousel__next {
  margin-right: 2rem;
}

.carousel__prev {
  margin-left: 2rem;
}
</style>
